import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'c2c_alternative_trans_mode',
    label,
    property,
});

const clickSearchEvent = (mode) => sendEvent('click', mode);

const events = {
    clickSearchEvent,
};

export default events;
